<template>
  <div id="CandidateAnswersComponent">
    <v-card
      v-if="loading"
      class="ma-3"
    >
      <v-card-text />
    </v-card>
    <v-expansion-panels
      v-else
      v-model="panel"
      class="pa-3"
      focusable
      multiple
    >
      <v-expansion-panel
        v-for="(section, index) in form.sections"
        :key="section.id"
      >
        <v-expansion-panel-header>Section {{ index + 1 }}: {{ section.name }}</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Question
                  </th>
                  <th class="text-left">
                    Your Answer
                  </th>
                  <th />
                </tr>
              </thead>
              <tbody v-if="loading === false">
                <tr
                  v-for="question in section.questions"
                  :key="question.id"
                >
                  <td width="30%">
                    {{ question.question }}
                  </td>
                  <td v-if="candidateAnswers !== null">
                    <img
                      v-if="question.question_type.type === 'signature'"
                      :src="signatureUrl(candidateAnswers[question.id])"
                    >
                    <div v-else-if="question.question_type.type === 'signature-combined'">
                      <img
                        :src="signatureUrl(JSON.parse(candidateAnswers[question.id]).url)"
                      >
                      {{ JSON.parse(candidateAnswers[question.id]).date }}
                      {{ JSON.parse(candidateAnswers[question.id]).full_name }}
                    </div>

                    <div v-else-if="isJSON(candidateAnswers[question.id]) && (question.question_type.type === 'checkboxes' || question.question_type.type === 'radio-buttons')">
                      {{ JSON.parse(candidateAnswers[question.id]).join(', ') }}
                    </div>

                    <div v-else>
                      {{ candidateAnswers[question.id] }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>
<script>
export default {
  name: 'CandidateAnswersComponent',
  props: {
    form: {
      type: Object,
      required: true
    },
    viewType: {
      type: String,
      required: true
    }
  },
  data: () => ({
    panel: [0],
    loading: true,
    candidateAnswers: null,
    candidate: null,
    candidateForAgency: null
  }),

  mounted () {
    this.setCandidate()
    this.candidateData()
  },
  methods: {
    signatureUrl (path) {
      const split = path.split('/')
      const filename = split[split.length - 1]
      return '/show-signature/' + filename
    },
    setCandidate () {
      this.candidateForAgency = window.location.pathname.split('/').pop()
    },
    axiosGetCandidate () {
      return axios
        .get('/api/current-logged-in-user')
        .then(response => {
          this.candidate = response.data.candidate
        })
    },
    candidateData () {
      if (this.viewType === 'agency') {
        this.axiosGetCandidate()
          .then(() => {
            this.answerData(this.candidateForAgency, this.form.id)
          })
      }
      if (this.viewType === 'candidate') {
        this.axiosGetCandidate()
          .then(() => {
            this.answerData(this.candidate.id, this.form.id)
          })
      }
    },
    answerData (id, formId) {
      axios
        .get('/api/forms/' + formId + '/answers/' + id)
        .then(response => {
          this.candidateAnswers = response.data
          this.loading = false
        })
    },
    isJSON (str) {
      try {
        return JSON.parse(str) && !!str
      } catch (e) {
        return false
      }
    }
  }
}
</script>
